import {Injectable} from "@angular/core";
import {ApiClient} from "../api-client";
import {Observable} from "rxjs";
import {ReleaseToggle} from "../release-toggles/release-toggle-state";
import {LocalizationStrings} from "../../i18n/i18n-model";
import {LanguageDefinition} from "../language-definition";

@Injectable()
export class AppInitService {

  constructor(private readonly apiClient: ApiClient) {
  }

  getAppInit(): Observable<AppInit> {
    return this.apiClient.get<AppInit>("/api/app-init");
  }
}

export interface AppInit {
  readonly releaseToggles: ReleaseToggle[];
  readonly localizations: LocalizationsByLanguage;
  readonly supportedLanguages: LanguageDefinition[];
}

export interface LocalizationsByLanguage {
  readonly [language: string]: LocalizationStrings;
}

export function toLocalizationsMap(localizations: LocalizationsByLanguage): Map<string, LocalizationStrings> {
  const map = new Map<string, LocalizationStrings>();
  Object.entries(localizations).forEach(([language, strings]) => map.set(language, strings));
  return map;
}
